import React,{ useEffect } from 'react';
import 'magnific-popup';
import $ from 'jquery';
import {Link} from 'react-router-dom'



function Faq({ afterElment }) {
  useEffect(()=>{


     /* magnificPopup video view */
    $('.popup-video').magnificPopup({
      type: 'iframe'
    });

  },[])

  
  return (

    <section className={afterElment + " faq-bg"}>
    <div className="container">
      <div className="row align-items-center">
        <div className="col-lg-6">
          <div className="faq-img-wrap">
            <img src="img/images/faq_tv.png" className="img-frame" alt="" />
            <img src="img/images/breeder_img04.png" className="main-img " alt="" />
            <Link to="/https://www.youtube.com/watch?v=XdFfCPK5ycw" className="popup-video" > </Link>
          </div>
        </div>
       <div className="col-lg-6">
  <div className="faq-wrapper">
    <div className="section-title mb-35">
      <h5 className="sub-title">Questions fréquentes</h5>
      <h2 className="title">Alimentation & Hygiène pour Chiens et Chats</h2>
    </div>
    <div className="accordion" id="accordionExample">
      <div className="card">
        <div className="card-header" id="headingOne">
          <h2 className="mb-0">
            <button className="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
              Quelle est la meilleure nourriture pour mon chien ou chat ?
            </button>
          </h2>
        </div>
        <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
          <div className="card-body">
            La meilleure alimentation dépend de la race, de l’âge et de l’état de santé de votre animal. Chez Goodies Pet Shop, nous proposons une gamme complète de croquettes et de pâtées hypoallergéniques et équilibrées.
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-header" id="headingTwo">
          <h2 className="mb-0">
            <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
              Quels produits recommandez-vous pour l’hygiène des animaux ?
            </button>
          </h2>
        </div>
        <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
          <div className="card-body">
            Nous recommandons des shampoings doux, des lingettes nettoyantes et des produits antiparasitaires naturels pour garder votre animal propre et en bonne santé.
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-header" id="headingThree">
          <h2 className="mb-0">
            <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
              À quelle fréquence dois-je nourrir mon animal ?
            </button>
          </h2>
        </div>
        <div id="collapseThree" className="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
          <div className="card-body">
            Les chiens adultes mangent généralement deux fois par jour, tandis que les chats peuvent avoir plusieurs petits repas. Suivez les recommandations sur l’emballage ou demandez conseil à notre équipe.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

      </div>
    </div>
    <div className="faq-shape"><img src="img/images/faq_shape.png" alt="" /></div>
  </section>
  )
}

export default Faq;
// import React, { useEffect, useState } from 'react';
// import 'magnific-popup';
// import $ from 'jquery';
// import { Link } from 'react-router-dom';
// import { supabase } from '../lib/supabaseClient.ts';

// function Faq({ afterElment }) {
//   const [faqs, setFaqs] = useState([]);
//   const [faqHeader, setFaqHeader] = useState({ subtitle: '', title: '' });

//   useEffect(() => {
//     const fetchSectionTitle = async () => {
//       const { data, error } = await supabase
//         .from('faq_section')
//         .select('*')
//         .single();

//       if (error) {
//         console.error('Error fetching FAQ section:', error);
//       } else {
//         setFaqHeader(data);
//       }
//     };

//     fetchSectionTitle();
//   }, []);
//   useEffect(() => {
//     $('.popup-video').magnificPopup({ type: 'iframe' });

//     const fetchFaqs = async () => {
//       const { data, error } = await supabase
//         .from('faq')
//         .select('*')
//         .order('order_index', { ascending: true });

//       if (error) {
//         console.error('Error fetching FAQs:', error);
//       } else {
//         setFaqs(data);
//       }
//     };

//     fetchFaqs();
//   }, []);

//   return (
//     <section className={afterElment + ' faq-bg'}>
//       <div className="container">
//         <div className="row align-items-center">
//           <div className="col-lg-6">
//             <div className="faq-img-wrap">
//               <img src={faqHeader.frame_image_url} className="img-frame" alt="" />
//               <img src={faqHeader.main_image_url} className="main-img" alt="" />

//               <Link to="/https://www.youtube.com/watch?v=XdFfCPK5ycw" className="popup-video" />
//             </div>
//           </div>

//           <div className="col-lg-6">
//             <div className="faq-wrapper">
//               <div className="section-title mb-35">
//                 <h5 className="sub-title">{faqHeader.subtitle}</h5>
//                 <h2 className="title">{faqHeader.title}</h2>

//               </div>
//               <div className="accordion" id="accordionExample">
//                 {faqs.map((faq, index) => (
//                   <div className="card" key={faq.id}>
//                     <div className="card-header" id={`heading${index}`}>
//                       <h2 className="mb-0">
//                         <button
//                           className={`btn btn-link btn-block text-left ${index !== 0 ? 'collapsed' : ''}`}
//                           type="button"
//                           data-toggle="collapse"
//                           data-target={`#collapse${index}`}
//                           aria-expanded={index === 0 ? 'true' : 'false'}
//                           aria-controls={`collapse${index}`}
//                         >
//                           {faq.question}
//                         </button>
//                       </h2>
//                     </div>
//                     <div
//                       id={`collapse${index}`}
//                       className={`collapse ${index === 0 ? 'show' : ''}`}
//                       aria-labelledby={`heading${index}`}
//                       data-parent="#accordionExample"
//                     >
//                       <div className="card-body">{faq.answer}</div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="faq-shape"><img src="img/images/faq_shape.png" alt="" /></div>
//     </section>
//   );
// }

// export default Faq;
